.base,
.base *,
.base *::before,
.base *::after {
  box-sizing: border-box;
}

.base {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  overflow: hidden;

  background: var(--bg-inset);
  border: 1px solid var(--border-default);
  border-radius: var(--radius-round);

  font-family: var(--font-sans);
  font-weight: var(--weight-semi);
  letter-spacing: var(--tracking-normal);
  color: var(--text-secondary);

  user-select: none;
  transition:
    background-color var(--duration-fast) var(--ease-default),
    border-color var(--duration-fast) var(--ease-default),
    color var(--duration-fast) var(--ease-default);
}

/* Component-local: 28/32/40 are off the 4px space scale. */
.sm {
  width: 28px;
  height: 28px;
  font-size: var(--text-xs);
}

.md {
  width: 32px;
  height: 32px;
  font-size: var(--text-sm);
}

.lg {
  width: 40px;
  height: 40px;
  font-size: var(--text-base);
}

.active {
  background: var(--accent-secondary-muted);
  border-color: var(--accent-secondary);
  color: var(--accent-secondary);
}

.image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

@media (prefers-reduced-motion: reduce) {
  .base {
    transition: none;
  }
}
